import { BodyTypes } from '../LevelManager';
import CharacterSpine from './CharacterSpine';
import { SpineEvents } from '../../core/enums/SpineEvents';
import { EquipmentTypeValues } from './VehicleEquipment';
import { VehicleEquipmentWeapon } from './VehicleEquipmentWeapon';
import { VehicleVillain } from './VehicleVillain';

export abstract class VehicleEquipmentMeleeWeapon extends VehicleEquipmentWeapon {
  protected camera: Phaser.Cameras.Scene2D.Camera;
  protected spine: CharacterSpine;
  protected bone: spine.Bone;
  protected animationName: string;

  protected hitbox: MatterJS.BodyType;
  // protected debugHitbox: Phaser.GameObjects.Rectangle;

  protected shouldRun: boolean;
  protected shouldCollide: boolean;
  protected shouldCollideYOnly: boolean;

  constructor(
    scene: Phaser.Scene,
    equipmentType: EquipmentTypeValues,
    vehicle: VehicleVillain,
    camera: Phaser.Cameras.Scene2D.Camera,
    spine: CharacterSpine,
    boneName: string,
    animationName: string
  ) {
    super(scene, equipmentType, vehicle);

    this.camera = camera;
    this.spine = spine;
    this.equipmentType = equipmentType;
    this.bone = this.spine.findBone(boneName);
    this.animationName = animationName;

    this.hitbox = this.makeHitbox();
    this.hitbox.gameObject = this;

    console.log('collision group:', this.hitbox.collisionFilter.group, this.hitbox.collisionFilter.category, this.hitbox.collisionFilter.mask);
    this.hitbox.collisionFilter.group = -1;
    this.hitbox.collisionFilter.category = 2;

    // this.debugHitbox = new Phaser.GameObjects.Rectangle(this.scene, 0, 0, 100, 100, 0xfff, 0.3);

    this.shouldRun = false;
    this.shouldCollide = false;
    this.shouldCollideYOnly = false;

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.cleanUp, this);

    // this.spine.on(SpineEvents.Start, this.animationStart, this);
    // this.spine.on(SpineEvents.End, this.animationEnd, this);
  }

  get Owner(): VehicleVillain {
    return this.vehicle;
  }

  public toggleRun(shouldRun: boolean) {
    this.shouldRun = shouldRun;
  }

  public toggleCollide(shouldCollide: boolean) {
    this.shouldCollide = shouldCollide;

    this.hitbox.collisionFilter.group = shouldCollide ? 0 : -1;
    this.hitbox.collisionFilter.category = shouldCollide ? 1 : 2;

    console.log(`Hitbox ${shouldCollide}`, this.scene.sys.game.loop.getDurationMS());
  }

  public toggleCollideY(shouldCollide: boolean) {
    this.shouldCollideYOnly = shouldCollide;
  }

  public abstract onHit(): void;

  public update(time: number, delta: number) {
    if (this.shouldRun) {
      if (this.shouldCollideYOnly && this.vehicle.VehicleManager.HeroVehicle?.y) {
        let bounds = (this.vehicle.VehicleManager.HeroVehicle.body as MatterJS.BodyType).bounds;
        if (bounds.max.y >= this.hitbox.bounds.min.y && bounds.min.y <= this.hitbox.bounds.max.y) {
          this.vehicle.VehicleManager.HeroVehicle.triggerWeaponCollision(this);
          this.toggleCollideY(false);
        }
      } else if (this.bone) {
        this.scene.matter.body.setPosition(this.hitbox, { x: this.bone.worldX + this.camera.scrollX, y: -this.bone.worldY - this.camera.scrollY });
        this.scene.matter.body.setVelocity(this.hitbox, { x: 0, y: 0 });

        // this.hitbox.position.x = this.bone.worldX + this.camera.scrollX;
        // this.hitbox.position.y = -this.bone.worldY - this.camera.scrollY;
      }
    }

    // if (this.shouldRun && this.bone) {

    // }

    // if (this.shouldRun && this.shouldCollideYOnly) {}
  }

  protected makeHitbox(): MatterJS.BodyType {
    return this.scene.matter.add.rectangle(0, 0, 225, 100, {
      label: BodyTypes.Weapon,
      isSensor: true
    });
  }

  protected animationStart(entry: spine.TrackEntry) {
    if (entry.animation.name == this.animationName) this.toggleCollide(true);
  }

  protected animationEnd(entry: spine.TrackEntry) {
    if (entry.animation.name == this.animationName) this.toggleCollide(false);
  }

  protected cleanUp() {
    this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);

    this.spine.off(SpineEvents.Start, this.animationStart, this);
    this.spine.off(SpineEvents.End, this.animationEnd, this);
  }
}
